(ns humbleai.belt.coll)

(defn separate
  "Returns a vector of two vectors. First vector will contain
   all the elements from <coll> that satisfy <pred>, whereas
   the second will contain the ones that do not.
   Essentially the equivalent of the following in 1-pass:

   ((juxt (partial filter pred)
          (partial remove pred))
     coll)"
  [pred coll]
  (let [ret (group-by (comp boolean pred) coll)]
    [(get ret true  [])
     (get ret false [])]))

(defn find-first
  "Returns the first element in <coll> that satisfies <pred>.
   Prefer this over `(first (filter pred coll))`."
  [pred coll]
  (some #(when (pred %) %) coll))

(defn group-by++
  "Returns a grouping of the elements in coll based on the result of
   kf on each element. The value at each key will be a vector of the
   corresponding elements, in the order they appeared in coll,
   passed through vf (defaults to `identity`).
   Essentially, the 2-arg arity behaves exactly like `clojure.core/group-by`,
   but the 3/4/5 arities offer more flexibility around the grouping containers,
   and the actual values within them."
  ([kf coll]
   (group-by++ kf [] coll))
  ([kf init coll]
   (group-by++ kf identity init coll))
  ([kf vf init coll]
   (group-by++ kf vf conj init coll))
  ([kf vf rf init coll]
   (persistent!
    (reduce
     (fn [ret x]
       (let [k (kf x)]
         (assoc! ret k (rf (get ret k init) (vf x)))))
     (transient {})
     coll))))
